import {
  createContext,
  useContext,
} from 'react'

// Answers every call by doing nothing, for wherever the widget is not loaded.
export const INERT_ZENDESK_API = {
  signIn: noop,
  signOut: noop,
  trackEvent: noop,
  updateUser: noop,
}

const ZendeskAPIContext = createContext(INERT_ZENDESK_API)


export default ZendeskAPIContext

export function useZendeskAPI() {
  return useContext(ZendeskAPIContext)
}

function noop() {
}
